import { RawDraftEntity } from 'draft-js';

const stripHash = (string: string) => string.replace('#', '');

export const renderHashtag = (entity: RawDraftEntity, text: string) => {
  if (entity.type !== '#mention') return;
  if (
    entity.data.mention.link &&
    entity.data.mention.link.indexOf('/tags/') !== -1
  ) {
    return `<span class="hash-without-link">${stripHash(text)}</span>`;
  }
  return `<a href="${
    entity.data.mention.link
  }" target="_blank" rel="noopener">${stripHash(text)}</a>`;
};
